/* eslint-disable multiline-ternary */
import React, { Fragment } from 'react'
import { BrandGroupProps } from './types'
import resolveProps from '../../utils/resolveProps'
import Brand from '../Brand'

import './index.scss'

const config = {
  types: [
    'sm',
    {
      title: 'md',
      isDefault: true
    },
    'lg'
  ],
  modifiers: [],
  state: []
}

function BrandGroup(props: BrandGroupProps) {
  const { sm, md, lg, brands } = props
  const displayedBrands = brands?.filter((brand) => brand?.isVisible === true)
  const hidedBrands = brands?.filter((brand) => brand?.isVisible === false)

  return (
    <ul className={resolveProps(props, config, 'BrandGroup')}>
      {displayedBrands?.map((brand, index) => (
        <li className="mdn-BrandGroup-item" tabIndex={0} aria-label={brand.alt } key={`displayed_item_${index}`}>
          <figure key={`displayed_${index}`} className="mdn-BrandGroup-image">
            <Brand
              sm={sm}
              md={md}
              lg={lg}
              src={brand.src}
              alt={`Imagem ${brand.alt}`}
            />
            <figcaption className="mdn-BrandGroup-image-caption mdn-Tooltip mdn-Tooltip--top">
              <p className="mdn-Text mdn-Text--caption mdn-Text--inverse">
                {brand.alt}
              </p>
            </figcaption>
          </figure>
        </li>
      ))}
      {hidedBrands.length >= 1 ? (
        <li className="mdn-BrandGroup-etc">
          <div
            className="mdn-BrandGroup-etc-value"
            aria-label={`Exibir mais ${hidedBrands.length}`}
            tabIndex={0}
          >
            +{hidedBrands.length}
            <div className="mdn-BrandGroup-etc-items mdn-Tooltip mdn-Tooltip--left mdn-Tooltip--content">
              <ul className="mdn-TopicDetails mdn-TopicDetails--brand">
                {hidedBrands.map((brand, index) => (
                  <li
                    key={`etc_${index}`}
                    className="mdn-TopicDetails-group"
                    tabIndex={0}
                  >
                    <div className="mdn-Topic mdn-Topic--horizontal mdn-Topic--sm">
                      <div className="mdn-Topic-symbol">
                        <img src={brand.src} alt={`Imagem ${brand.alt}`} />
                      </div>
                      <p className="mdn-Topic-description" aria-hidden="true">
                        {brand.alt}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </li>
      ) : (
        ''
      )}
    </ul>
  )
}

export default BrandGroup
